export default "__VITE_ASSET__DnFD3104__"